/** LUCRUL NESCRIS: cine are ceva nesalvat pe ecran și întrebarea de dinainte de
 *  a pleca de la el.
 *
 *  DE CE EXISTĂ. Editorul de tronsoane avea `beforeunload` — bun pentru
 *  închiderea filei și pentru reîncărcare, și DEGEABA pentru tot restul:
 *  navigarea dinăuntrul aplicației nu trece prin browser, ci prin router, deci
 *  săgeata «înapoi la colecție» și butoanele railului lăsau ecranul cu tot ce
 *  nu era salvat, fără o vorbă. Măsurat: pui o piesă de mobilier, apeși
 *  săgeata, te întorci — piesa nu mai e. Raportat de Stefan (17.09.2026):
 *  «pare chiar că în anumite cazuri nu îmi salvează modificările».
 *
 *  CUM. Ecranul care are de pierdut ceva lasă aici o întrebare; locurile prin
 *  care se pleacă — railul, sigla, săgeata editorului — o pun înainte să
 *  navigheze. O singură întrebare la un moment dat: două ecrane cu lucru
 *  nesalvat deodată n-ar putea exista, fiindcă numai unul e pe ecran.
 *
 *  `useBlocker` al routerului ar fi fost calea, dar el cere un «data router»
 *  (`createBrowserRouter`), iar aplicația merge pe `<BrowserRouter>`; portița
 *  asta e ce se poate face fără să mutăm tot routerul.
 *
 *  CE NU ACOPERĂ: butonul «înapoi» al BROWSERULUI. `popstate` vine după ce
 *  istoricul s-a mutat, iar întoarcerea lui e un truc pe care nu-l merită
 *  cazul. Rămâne `beforeunload` pentru filă și întrebarea asta pentru
 *  navigarea din aplicație.
 */

/** Întrebarea ecranului curent: `true` = pot pleca. */
let intrebarea: (() => boolean) | null = null;

/** Ecranul cu lucru nesalvat își lasă întrebarea aici; `null` o retrage.
 *  Se cheamă dintr-un `useEffect`, iar curățenia lui o retrage la demontare. */
export function tineNescrisul(f: (() => boolean) | null): void {
  intrebarea = f;
}

/** Locul prin care se pleacă întreabă înainte să navigheze.
 *
 *  Fără nicio întrebare pusă — adică niciun ecran cu lucru nesalvat — răspunsul
 *  e `true`: portița nu are voie să stea în calea navigării obișnuite.
 */
export function potPleca(): boolean {
  return intrebarea ? intrebarea() : true;
}
